// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "../../../assets/css/functions";
@import "../../../assets/css/mixins";
@import "../../../assets/css/perfect-scrollbar";
@import "../../../assets/css/config";
@import "../../../assets/css/aside";
@import "../../../assets/css/eskatheme";
@import "../../../assets/plugins/global/plugins.bundle.css";

.eska-submenu{
    border : 1px black solid;
} */
.eska-menu-group {
  margin: 0;
  list-style: none;
  padding: 15px 0;
}
.eska-menu-group-item {
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  float: none;
  padding: 0;
}
.eska-menu-group-item a {
  display: flex;
  flex-grow: 1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  text-decoration: none;
  position: relative;
  outline: none;
  padding: 9px 25px;
  cursor: pointer;
  min-height: 44px;
  color: #fff;
}
.eska-menu-group-item a:hover {
  background-color: #00527a;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/aside/aside-left.component.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;GAAA;AAWA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,YAAA;EACA,WAAA;EACA,UAAA;AACJ;AACI;EAGE,aAAA;EAGA,YAAA;EAGA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACN;AAUM;EACE,yBAAA;AARR","sourcesContent":["/* @import \"../../../assets/css/functions\";\r\n@import \"../../../assets/css/mixins\";\r\n@import \"../../../assets/css/perfect-scrollbar\";\r\n@import \"../../../assets/css/config\";\r\n@import \"../../../assets/css/aside\";\r\n@import \"../../../assets/css/eskatheme\";\r\n@import \"../../../assets/plugins/global/plugins.bundle.css\";\r\n\r\n.eska-submenu{\r\n    border : 1px black solid;\r\n} */\r\n.eska-menu-group {\r\n  margin: 0;\r\n  list-style: none;\r\n  padding: 15px 0;\r\n\r\n  &-item {\r\n    position: relative;\r\n    margin: 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-flex: 1;\r\n    -ms-flex-positive: 1;\r\n    flex-grow: 1;\r\n    float: none;\r\n    padding: 0;\r\n\r\n    a {\r\n      display: -webkit-box;\r\n      display: -ms-flexbox;\r\n      display: flex;\r\n      -webkit-box-flex: 1;\r\n      -ms-flex-positive: 1;\r\n      flex-grow: 1;\r\n      -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n      align-items: stretch;\r\n      margin: 0;\r\n      padding: 0;\r\n      text-decoration: none;\r\n      position: relative;\r\n      outline: none;\r\n      padding: 9px 25px;\r\n      cursor: pointer;\r\n      min-height: 44px;\r\n      color: #fff;\r\n\r\n      // + div{\r\n      //   display: none;\r\n      // }\r\n\r\n      // &.active{\r\n      //   + div{\r\n      //     display: block;\r\n      //   }\r\n      // }\r\n      &:hover {\r\n        background-color: #00527a;\r\n      }\r\n    }\r\n\r\n\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
